<template>
  <div class="alipay-flow-page">
    <div class="phone-screen">
      <img class="screen-image" :src="screenImage" alt="支付宝首页" />
      <button
        class="hotspot search-bar"
        type="button"
        aria-label="点击搜索栏"
        @click="goSearch"
      />
      <button
        class="hotspot my-tab"
        type="button"
        aria-label="点击我的"
        @click="goMy"
      />
    </div>
  </div>
</template>

<script>
import screenImage from "@/assets/alipay-flow-home-no-status.png";

export default {
  name: "AlipayFlowHome",
  data() {
    return {
      screenImage,
    };
  },
  methods: {
    goSearch() {
      this.$router.push({ name: "AlipayFlowSearch" });
    },
    goMy() {
      this.$router.push({ name: "AlipayMyPage" });
    },
  },
};
</script>

<style scoped>
.alipay-flow-page {
  min-height: 100vh;
  background: #eff2f7;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  box-sizing: border-box;
}

.phone-screen {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  overflow: visible;
  border-radius: 0;
}

.screen-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: fill;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
}

.hotspot {
  position: absolute;
  border: none;
  background: transparent;
  cursor: pointer;
}

.search-bar {
  left: 16%;
  top: 3.8%;
  width: 66%;
  height: 5.7%;
}

.my-tab {
  right: 0.5%;
  bottom: 0%;
  width: 16.5%;
  height: 8.5%;
}
</style>
